import React from 'react';

import CalendarContainer from './calendarContainer';
import CalendarGridMonth from './calendarGridMonth';
import CalendarHeaderMonth from './calendarHeaderMonth';

const CalendarMonth = () => {
    return (
        <>
            <CalendarHeaderMonth />
            <CalendarContainer>
                <CalendarGridMonth />
            </CalendarContainer>
        </>
    );
};

export default React.memo(CalendarMonth);
